// UserPool information needed for connecting with cognito

import {CognitoUserPool} from 'amazon-cognito-identity-js';

const poolData = {
    UserPoolId: "us-east-1_eeVaZRxlT",
    ClientId: "1k75ho2qv49psn5srsh00vi3a6"
}

export default new CognitoUserPool(poolData)